// extracted by mini-css-extract-plugin
export default {"avarie__container":"style_avarie__container__SXhoi","avarie__container__icon":"style_avarie__container__icon__2yH7M"};